import LinkWrap from "../../../../components/LinkWrap/component";
import {
    summerLogoDesktop,
    summerLogoMobile,
    paraLogoDesktop,
    paraLogoMobile,
    winterLogo,
} from "./logos";
import featureAttr from "../../../../utils/featureAttr";

const OlympicsBrandBanner = ({ season = null, url, logo = null }) => {
    if (season !== "summer" && season !== "winter" && season !== "paralympics")
        return null;
    const olympicsHomeUrl = url ? url : `/sports/olympics`;

    if (season === "summer") {
        return (
            <LinkWrap url={olympicsHomeUrl}>
                <div
                    className="summerOlympicsBrandBanner"
                    data-feature-name={"banner"}
                    data-testid={"olympics-banner"}
                    data-cy={"olympics-banner"}
                >
                    <div className="summerOlympicsBannerImage desktop">
                        {summerLogoDesktop}
                    </div>
                    <div className="summerOlympicsBannerImage mobile">
                        {summerLogoMobile}
                    </div>
                </div>
            </LinkWrap>
        );
    }
    if (season === "winter") {
        return (
            <LinkWrap className="bannerFocus" url={olympicsHomeUrl}>
                <div
                    className="winterOlympicsBrandBanner"
                    {...featureAttr({ name: "banner", instance: "Beijing" })}
                    data-testid={"olympics-banner"}
                >
                    <div className="winterOlympicsBrandBannerBricks">
                        {logo ? logo : winterLogo}
                    </div>
                </div>
            </LinkWrap>
        );
    }
    if (season === "paralympics") {
        return (
            <LinkWrap url={"/sports/paralympics"}>
                <div
                    className="summerOlympicsBrandBanner"
                    data-feature-name={"banner"}
                    data-testid={"olympics-banner"}
                    data-cy={"olympics-banner"}
                >
                    <div className="summerOlympicsBannerImage desktop">
                        {paraLogoDesktop}
                    </div>
                    <div className="summerOlympicsBannerImage mobile">
                        {paraLogoMobile}
                    </div>
                </div>
            </LinkWrap>
        );
    }
};

export default OlympicsBrandBanner;
